import React from 'react';
import Firebase from 'firebase';
import XLSX from 'xlsx';
var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);



export default class addFromFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: {},
            option: "excel",
            display: "none"
        }
        this.filePicked = this.filePicked.bind(this);
        this.csvTojs = this.csvTojs.bind(this);
    }

    csvTojs() {
        var contex = this;
        var reader = new FileReader();
        // Read file into memory as UTF-8      
        reader.readAsText(this.state.file);
        // Handle errors load
        reader.onload = function (e) {
            contex.loadHandler(e);
            reader.onerror = contex.errorHandler(e);
        }
    }

    loadHandler(event) {
        var csv = event.target.result;
        this.processData(csv);
    }

    processData(csv) {
        var done = false;
        var allTextLines = csv.split(/\r\n|\n/);
        var lines = [];
        for (var i = 0; i < allTextLines.length; i++) {
            var data = allTextLines[i].split(';');
            var tarr = [];
            for (var j = 0; j < data.length; j++) {
                tarr.push(data[j]);
            }
            if (i == 0) {
                this.setState({ titles: tarr });
            } else {
                var arrObj = [];
                var obj = {};
                for (var h = 0; h < tarr.length; h++) {
                    var key = this.state.titles[h];
                    obj[key] = tarr[h];
                }
                lines.push(obj);
            }
        }
        const contex = this;
        var data = Object.assign({}, lines);
        var dataSetRef = Firebase.database().ref('stores').child(localStorage.client_id);
        if (this.state.titles.length >= 2) {
            dataSetRef.set(Object.values(data)).then(resp => {
                contex.props.callBack();
                contex.refs.container.success(
                    "Fichero añadido correctamente",
                    "upload files.", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
            }).catch(err => {
                contex.refs.container.warning(
                    "Fichero no fue añadido, verifique que contenga al menos dos columnas",
                    "upload files.", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
            });
        }
    }

    errorHandler(evt) {
    }
    filePicked() {
        
        const contex = this;
        // Get The File From The Input
        var oFile = this.state.file;
        var sFilesheetName = oFile.sheetName;
        // Create A File Reader HTML5
        var reader = new FileReader();

        // Ready The Event For When A File Gets Selected
        reader.onload = function (e) {
            var data = e.target.result;
            var cfb = XLSX.read(data, { type: 'binary' });

            // Loop Over Each Sheet
            // Obtain The Current Row As CSV
            var newPostKey = Firebase.database().ref().child('datasets').push().key;
            var dataSetRef = Firebase.database().ref('stores').child(localStorage.client_id);
            var oJS = XLSX.utils.sheet_to_json(cfb.Sheets[cfb.SheetNames[0]]);
            var data = Object.values(oJS);
            var titles = [];
            Object.keys(data[0]).map((title, index) => {
                var tt = "000" + index + "_" + title
                titles.push(tt)
            })
            var arrData = [];
            data.map((filas, index) => {
                var subData = {}
                Object.values(filas).map((subFila, indexY) => {
                    subData[titles[indexY]] = subFila;
                })
                arrData.push(subData)
            })
            dataSetRef.set(Object.values(arrData)).then(resp => {
                contex.props.callBack();
            }).catch(err => {
            });
        };

        // Tell JS To Start Reading The File.. You could delay this if desired
        reader.readAsBinaryString(oFile);
    }

    render() {
        var reader = new FileReader();
        var metadata = {
            contentType: 'application/vnd.ms-excel'
        };
        const contex = this;
        return (
            <div className="row">
                <div className="col-sm-12">
                    <ToastContainer ref="container"
                        toastMessageFactory={ToastMessageFactory}
                        className="toast-top-right" />
                    {/* <div className="form-group row">
                        <label className="col-md-3 form-control-label">Inline Radios</label>
                        <div className="col-md-9">
                            <div className="radio">
                                <label htmlFor="inline-radio1">
                                    <input type="radio" id="inline-radio1" name="inline-radios" value="excel" onClick={(e) => { this.setState({ option: e.target.value, display: "" }) }} /> Planilla Excel
                            </label>
                            </div>
                            <div className="radio">
                                <label htmlFor="inline-radio2">
                                    <input type="radio" id="inline-radio2" name="inline-radios" value="csv" onClick={(e) => { this.setState({ option: e.target.value, display: "" }) }} /> Archivo CSV
                            </label>
                            </div>
                        </div>
                    </div> */}
                    <div className="form-group" style={{ width: "80%", marginLeft: "10%" }}>
                        <div className="input-group image-preview">
                            <input placeholder="" type="text" className="form-control image-preview-filesheetName"
                                value={this.state.file ? this.state.file.name : ""} disabled="disabled"
                            />
                            <span className="input-group-btn">
                                <button
                                    type="button"
                                    className="btn btn-default image-preview-clear"
                                    style={{ display: "none" }}>
                                    <span
                                        className="glyphicon glyphicon-remove">
                                    </span>
                                    Clear
                                </button>
                                <div  className="btn btn-primary image-preview-input" onClick={() => { var l = document.getElementById('inputFile'); l.click(); }} >
                                    <span
                                        className="image-preview-input-title">
                                        Buscar
                                    </span>
                                    <input
                                        style={{ display: "none" }}
                                        id="inputFile"
                                        type="file"
                                        accept=".xlsx,.xls"
                                        sheetName="input-file-preview"
                                        onChange={(e) => {
                                            this.setState({ file: e.target.files[0], display: "" });
                                        }}
                                    />
                                </div>
                            </span>
                            <div style={{ display: this.state.display }} >
                                {
                                    this.state.file !== {} ?
                                        this.state.option == "excel" ?
                                            <a  onClick={() => this.filePicked()} className="btn btn-success">Subir Archivo</a>
                                            :
                                            <a  onClick={() => this.csvTojs()} className="btn btn-success">Subir Archivo</a>
                                        :
                                        ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/stores/addFromFile.js